// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2YNvf","title":"AfterFrontImage_title__23oZR"};